import { Model } from "@vuex-orm/core";
import CustomerLookup from "./CustomerLookup";

export default class MessageLookup extends Model {
  static entity = "messageLookups";

  static fields() {
    return {
      id: this.attr(),
      customerId: this.number(0),
      messageType: this.string("sms"),
      messageBody: this.attr(),
      isUnread: this.boolean(false),
      isSnoozed: this.boolean(false),
      isArchived: this.boolean(false),
      haveNotResponded: this.boolean(false),
      customer: this.belongsTo(CustomerLookup, "customerId"),
      messageCreatedAt: this.attr(),
      messagesSnoozedUntil: this.attr()
    };
  }
}
